import TeamsTab from './TeamsTab.vue';
export default TeamsTab;
